import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const verifyOtpKYC = createAsyncThunk(
  "verifyOtpKYC/verifyOtpKYCUsers",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.post("KYC-details/verify-otp", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const verifyOtpKYCSlice = createSlice({
  name: "verifyOtpKYC",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtpKYC.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtpKYC.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(verifyOtpKYC.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default verifyOtpKYCSlice.reducer;
